<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="flying-with-wings-on-fire">
<h1>Flying with Wings on Fire</h1>
<p style="text-indent:0em">We were fast cars, back road racing,</p>
<p style="text-indent:0em">kids with no missions</p>
<p style="text-indent:0em">except the next good time</p>
<p style="text-indent:0em">around the next curve or corner,</p>
<p style="text-indent:0em">flying with wings on fire.</p><br/>
<p style="text-indent:0em">We were a small-town road show,</p>
<p style="text-indent:0em">fast friends sharing life at 3-digit speeds,</p>
<p style="text-indent:0em">and that wild man wild times bullet-proof</p>
<p style="text-indent:0em">young man kind of life,</p>
<p style="text-indent:0em">just flying with wings on fire.</p><br/>
<p style="text-indent:0em">Eating life like a buffet</p>
<p style="text-indent:0em">of crazy endless days</p>
<p style="text-indent:0em">and never-ending roads,</p>
<p style="text-indent:0em">daredevils laughing at it all,</p>
<p style="text-indent:0em">just flying with wings on fire.</p><br/>
<p style="text-indent:0em">And then one day we watched</p>
<p style="text-indent:0em">as they put out your fire</p>
<p style="text-indent:0em">and folded your wings,</p>
<p style="text-indent:0em">too young to be</p>
<p style="text-indent:0em">flying no more.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?c2aa2e5e